export var DataClass;
(function (DataClass) {
    DataClass["Fi"] = "FI";
    DataClass["Phi"] = "PHI";
    DataClass["Pii"] = "PII";
    DataClass["DataClassUnspecified"] = "DATA_CLASS_UNSPECIFIED";
})(DataClass || (DataClass = {}));
